/**
 * Сколько столбиков рисовать и что в каждом.
 *
 * СТОЛБИК НА СУТКИ — ТОЛЬКО ПОКА СУТОК МАЛО. За 90 дней это девяносто
 * столбиков в ста пикселях, то есть полоска шириной в волос, по которой
 * формы не прочитать вовсе, — а столбики стоят в таблице ровно ради
 * формы. Сутки сбиваются в пачки так, чтобы столбиков осталось не
 * больше ВОСЬМИ: неделя — семь, месяц — восемь по четверо суток,
 * квартал — восемь по дюжине.
 *
 * ВОСЕМЬ — ЧИСЛО ЭТАЛОНА, А НЕ КРУГЛОЕ. Столбец «Динамика» там шириной
 * 84 пикселя (`colDef`), а в клетке нарисовано восемь столбиков
 * по шесть с промежутком три: 8 × 6 + 7 × 3 = 69 плюс поля клетки 16.
 * Стояло четырнадцать — и столбец выходил 148 против эталонных 91,
 * то есть шире на пятьдесят семь; таблица целиком — 1684 против 1599.
 *
 * ПАЧКИ НАБИРАЮТСЯ С КОНЦА, а не с начала. Последние сутки — те, ради
 * которых на график и смотрят; неполной может оказаться только самая
 * старая пачка, и она стоит с краю, где ошибка стоит меньше всего.
 * Что пачка неполная, видно из подсказки — «3 сут», а не «7 сут».
 *
 * НЕПОЛНАЯ ПАЧКА НЕ ДОТЯГИВАЕТСЯ ДО ПОЛНОЙ. Домножить её на недостающие
 * сутки значит нарисовать заказы, которых не было. Пусть выглядит
 * ниже — это правда: за трое суток заказов и правда меньше, чем
 * за семеро.
 *
 * ЗДЕСЬ ТОЛЬКО СЧЁТ. Ни DOM, ни React.
 */

export interface Bar {
  /** Сумма заказов в пачке. */
  orders: number;
  /** Сколько суток в пачке. У самой старой бывает меньше остальных. */
  days: number;
}

/** Больше не влезает в столбец таблицы, не превращаясь в смазанную полоску. */
export const MAX_BARS = 8;

export function barsOf(daily: readonly number[], max = MAX_BARS): Bar[] {
  if (daily.length === 0) return [];
  if (daily.length <= max) return daily.map((orders) => ({ orders, days: 1 }));

  const size = Math.ceil(daily.length / max);
  const bars: Bar[] = [];
  // С КОНЦА: последняя пачка обязана быть полной
  for (let end = daily.length; end > 0; end -= size) {
    const start = Math.max(0, end - size);
    let orders = 0;
    for (let i = start; i < end; i += 1) orders += daily[i]!;
    bars.unshift({ orders, days: end - start });
  }
  return bars;
}

/** «7 сут» — у слова «сутки» нет единственного числа. */
export function saySpan(days: number): string {
  return days === 1 ? 'сутки' : `${days} сут`;
}
